<template>
<div class="chapter">
<div class="inner_page">
<p class="fm"><a id="page_vii"></a>The Lightning climbed vertically in reheat into the darkening sky, and the reheat extinguished at exactly the same time that the music stopped. It was a very poignant moment, and a few tears were shed…</p>
<p class="fm1">…But before then a few things would have to happen, if I was to fly a <span href="#/xhtml/26_Glossary#g100" id="g_100" title="Link target outside of Sample">Lightning</span>.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Frontmatter.vue?0fffb7c6